import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'purchase-order',
        loadComponent: () =>
            import('./pages/purchase-order-page/purchase-order-page.component').then(m => m.PurchaseOrderPageComponent)
    },
    {
        path: 'payment-success',
        loadComponent: () =>
            import('./pages/stripe-redirect/stripe-success-page/stripe-success-page.component').then(
                m => m.StripeSuccessPageComponent
            )
    },
    {
        path: 'payment-cancelled',
        loadComponent: () =>
            import('./pages/stripe-redirect/stripe-cancelled-page/stripe-cancelled-page.component').then(
                m => m.StripeCancelledPageComponent
            )
    },
    {
        path: '**',
        redirectTo: '/purchase-order'
    }
];
